var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#383838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5452 7.54378L14.254 8.83497L17.1651 11.746L18.4563 10.4548L15.5452 7.54378ZM12.7456 8.2629C12.8892 8.11937 13.0822 8.05552 13.2698 8.07135L14.7259 6.61524C14.9432 6.39795 15.2379 6.27588 15.5452 6.27588C15.8525 6.27588 16.1472 6.39795 16.3645 6.61524L19.3848 9.63554C19.6021 9.85283 19.7242 10.1475 19.7242 10.4548C19.7242 10.7621 19.6021 11.0568 19.3848 11.2741L17.9287 12.7303C17.9445 12.9178 17.8806 13.1109 17.7371 13.2544C17.5936 13.3979 17.4006 13.4618 17.213 13.4459L11.2741 19.3848C11.1665 19.4924 11.0388 19.5777 10.8982 19.636C10.7577 19.6942 10.607 19.7242 10.4548 19.7242H7.43454C7.12725 19.7242 6.83254 19.6021 6.61524 19.3848C6.39795 19.1675 6.27588 18.8728 6.27588 18.5655V15.8008V15.5452C6.27588 15.393 6.30585 15.2424 6.36408 15.1018C6.42231 14.9612 6.50765 14.8335 6.61524 14.7259L12.5541 8.78706C12.5383 8.59948 12.6021 8.40644 12.7456 8.2629ZM7.51179 17.2684V18.4882H8.73162L7.51179 17.2684ZM10.3139 18.4882L7.51179 15.6862V15.5772L13.3177 9.77128L16.2288 12.6823L10.4228 18.4882H10.3139Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressPencil);
export default __webpack_public_path__ + "static/media/addressPencil.71efd94bfa957d80d52606b0a1662196.svg";
export { ForwardRef as ReactComponent };